import type { AnimationState, AvatarType, Direction } from "@aproape/shared";

export function spritePairIndex(_avatarType: AvatarType, moving: boolean, elapsed: number): 0 | 1 {
  if (!moving) return 0;
  return (Math.floor(elapsed / 0.14) % 2) as 0 | 1;
}

export function idleBreathScale(elapsed: number): { x: number; y: number } {
  const wave = Math.sin(elapsed * 2.1);
  return {
    x: 1 - wave * 0.003,
    y: 1 + wave * 0.008,
  };
}

export function avatarOverlayOffset(lounging: boolean): number {
  return lounging ? 140 : 0;
}

export function fountainDropletPosition(index: number, elapsed: number): { x: number; y: number; alpha: number; scale: number } {
  const safeIndex = Math.max(0, Math.floor(index));
  const side = safeIndex % 2 === 0 ? -1 : 1;
  const lane = Math.floor(safeIndex / 2) % 3;
  const progress = (elapsed * (0.64 + lane * 0.055) + safeIndex * 0.137) % 1;
  const arc = Math.sin(Math.PI * progress);
  return {
    x: side * (7 + (43 + lane * 7) * progress),
    y: -43 - arc * (59 + lane * 6) + progress * 39,
    alpha: arc * 0.88,
    scale: 0.55 + arc * 0.55,
  };
}

export interface AnimationFrame { state: AnimationState; direction: Direction; frame: number; bob: number; stride: number; armSwing: number; breath: number; headTilt: number }

export class AvatarAnimationController {
  private elapsed = 0;
  update(deltaSeconds: number, moving: boolean, direction: Direction): AnimationFrame {
    this.elapsed += deltaSeconds;
    const walkWave = Math.sin(this.elapsed * 10.5);
    const idleWave = Math.sin(this.elapsed * 2.1);
    const frame = moving ? Math.floor(this.elapsed * 10) % 4 : 0;
    return {
      state: moving ? "walking" : "idle",
      direction,
      frame,
      bob: moving ? Math.abs(Math.sin(this.elapsed * 10.5)) * 2.2 : 0,
      stride: moving ? walkWave : 0,
      armSwing: moving ? -walkWave : 0,
      breath: moving ? 0 : idleWave * 0.012,
      headTilt: moving ? walkWave * 0.012 : 0,
    };
  }
}
